import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
const ForgotPasswordForm = forwardRef(function (props, ref) {
    const { onSubmit } = props;
    const { register, handleSubmit, formState } = useForm({
        defaultValues: {
            password: '',
        },
    });
    useImperativeHandle(ref, () => ({
        handleSubmitForm: () => {
            handleSubmit((data) => onSubmit({
                password: data.password,
            }))();
        },
    }));
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.password, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, { htmlFor: 'outlined-username' }, "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(OutlinedInput, Object.assign({ id: 'outlined-email', label: '\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C' }, register('password', {
                required: true,
                pattern: config.passwordPolicyPattern,
            }))),
            React.createElement(FormHelperText, null,
                "\u041D\u0435 \u043A\u043E\u0440\u043E\u0447\u0435 ",
                config.passwordPolicyLength,
                " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432: \u0437\u0430\u0433\u043B\u0430\u0432\u043D\u0430\u044F \u0438 \u0441\u0442\u0440\u043E\u0447\u043D\u0430\u044F \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u0430."))));
});
export default ForgotPasswordForm;
